import {Api} from './api';
import Poller from './helpers/Poller';
import {mergeFileSettings} from './helpers/FileHelpers';

export function createOrgFiles(orgId, files, component) {
  let formData = new FormData();
  let settings = {};

  files.map(file => {
    // Add the file to the request.
    formData.append('assets[]', file, file.name);
    // add the dimensions to an object
    settings = mergeFileSettings(settings, file);
  });
  formData.append('settings', JSON.stringify(settings));

  return Api.upload(`/orgs/${orgId}/assets`, formData).then(json => {
    component.setState({
      loading: true,
      loadingMessage: 'Uploading new organization files.'
    });
    setTimeout(
      () => {window.location = `/orgs/${orgId}/assets`},
      5000
    );
  }).catch( err => {
    console.log(err.message);
  });
}
